import { useSelector } from 'react-redux';

import { AppState } from '@src/store/types';

const useThemeName = () => {
  return useSelector<AppState>((state) => state.theme.name);
};

export default useThemeName;
